import { render, staticRenderFns } from "./PreviewModeBgColorOnly.vue?vue&type=template&id=be6d5666&scoped=true"
import script from "./PreviewModeBgColorOnly.vue?vue&type=script&lang=js"
export * from "./PreviewModeBgColorOnly.vue?vue&type=script&lang=js"
import style0 from "./PreviewModeBgColorOnly.vue?vue&type=style&index=0&id=be6d5666&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be6d5666",
  null
  
)

export default component.exports